import React, { useState, useEffect, useMemo } from 'react';
import { Form, Button, Modal, Alert, Col, Row, Stack, Container } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import DatePicker from 'react-date-picker'
import ProfileFieldBase from './ProfileFieldBase'

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

import { dateOnlyFormatter } from '../../../utils/dateFormatter'

import styles from './UserProfile.module.scss'

export default function ProfileFieldDate({ profileLine, isEditMode, setValue }) {
  const { t } = useTranslation();

  // Parse initial date value safely
  const parseInitialDate = (value) => {
    if (!value) return null;
    // If it's already a Date object, use it
    if (value instanceof Date) return value;
    // If it's a string (YYYY-MM-DD or ISO format), parse it without timezone issues
    if (typeof value === 'string') {
      // For date-only strings like "1990-05-15", append time to prevent timezone shift
      const dateStr = value.includes('T') ? value.split('T')[0] : value;
      const [year, month, day] = dateStr.split('-').map(Number);
      if (year && month && day) {
        return new Date(year, month - 1, day); // Use local date constructor
      }
    }
    return null;
  };

  const [date, setDate] = useState(parseInitialDate(profileLine.value));

  useEffect(() => {
  }, []);

  const onSetDate = (newDate) => {
    setDate(newDate);

    if (setValue) {
      if (newDate) {
        // Convert to YYYY-MM-DD format (date-only, no timezone)
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
        const dateStr = `${year}-${month}-${day}`;
        setValue(dateStr);
      } else {
        setValue(null);
      }
    }
  };

  return (
    <>
      <ProfileFieldBase profileLine={profileLine} isEditMode={isEditMode} value={dateOnlyFormatter(profileLine.value)}>
        <DatePicker format="dd-MM-yyyy" showLeadingZeros={false} onChange={onSetDate} value={date} className={`form-control ${styles.calendarInput}`} />
      </ProfileFieldBase>
    </>
  );
}